import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tooltip, Icon, InputNumber, Upload, message } from "antd";
import InputForm from "./InputForm";
import { CPFValido, CNPJValido } from '../utils/Validator';
import { maskCNPJ, maskTelefone } from '../utils/Masker';
import axios from 'axios';
import "./Form.css";
import moment from "moment-timezone";
import MunicipioFrame from './MunicipioFrame';

const { Item: ItemForm } = Form;

export const OPCOES_COMBO_AMBIENTE = [
  { key: '1', label: '1 - PRODUÇÃO' },
  { key: '2', label: '2 - HOMOLOGAÇÃO' },
]

export const OPCOES_COMBO_RT = [
  { key: '1', label: 'Simples Nacional' },
  { key: '2', label: 'Simples Nacional, excesso sublimite de receita bruta' },
  { key: '4', label: 'MEI' },
]




export default class EmitenteForm extends Component {
  state = {
    registro: {
      enf_idf: 0,
      enf_cnpj: '',
      enf_razao_social: '',
      enf_ambiente: { key: '1' },
      enf_enviar_nf_emissao: 0,


      enf_flag_nfe: 0,
      enf_nfe_numero: 0,
      enf_nfe_serie: 0,

      enf_flag_nfce: 0,
      enf_nfce_numero: 0,
      enf_nfce_serie: 0,
      enf_csc: '',
      enf_idcsc: '',

      enf_flag_nfse: 0,
      enf_nfse_numero: 0,
      enf_nfse_serie: 0,
      enf_login_prefeitura: '',
      enf_senha_prefeitura: '',

      enf_data_certificado: '',
      enf_cnae: '',
      enf_crt: '',
      enf_ie: '',
      enf_im: '',

      enf_email: '',
      enf_telefone: '',
      enf_cep: 0,
      enf_endereco: '',
      enf_num_ender: '',
      enf_compl_ender: '',
      enf_bairro: '',
      enf_municipio: { key: '0' },

      enf_token_homolog: '',
      enf_token_producao: '',
      enf_webhook: '',
      enf_senha_certificado: '',
      enf_certificado: '',
      enf_certificado_nome: '',
      certificado_local: false,
    },
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado
      }, () => {
        // this.refs.enf_cnpj.focus();
      });
    }
  }



  onOK = () => {
    if ((!this.state.registro.enf_cnpj) || (this.state.registro.enf_cnpj === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o CNPJ' });
      return;
    }
    const PFJ = this.state.registro.enf_cnpj
      ? String(this.state.registro.enf_cnpj)
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '')
      : '';
    if (!CNPJValido(PFJ)) {
      Modal.warning({ title: 'Aviso!', content: 'CNPJ Inválido' });
      return;
    } if ((!this.state.registro.enf_razao_social) || (this.state.registro.enf_razao_social === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Razão Social' });
      return;
    }
    if ((!this.state.registro.enf_municipio) || (this.state.registro.enf_municipio.key === '0') || (this.state.registro.enf_municipio.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Município' });
      return;
    }

    if (this.state.registro.enf_certificado && !this.state.registro.enf_senha_certificado) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a senha do certificado digital' });
      return;
    }

    this.state.registro.enf_cnpj = this.state.registro.enf_cnpj.toUpperCase().replace(/[^A-Z0-9]/g, '');
    this.state.registro.enf_cnae = this.state.registro.enf_cnae ? this.state.registro.enf_cnae.toUpperCase().replace(/[^A-Z0-9]/g, '') : '';
    this.state.registro.enf_ie = this.state.registro.enf_ie ? this.state.registro.enf_ie.toUpperCase().replace(/[^A-Z0-9]/g, '') : '';
    this.state.registro.enf_im = this.state.registro.enf_im ? this.state.registro.enf_im.toUpperCase().replace(/[^A-Z0-9]/g, '') : '';
    this.state.registro.enf_crt = this.state.registro.enf_crt && this.state.registro.enf_crt.key ? this.state.registro.enf_crt.key : '0';
    this.state.registro.enf_cep = this.state.registro.enf_cep ? String(this.state.registro.enf_cep).toUpperCase().replace(/[^A-Z0-9]/g, '') : '';
    this.state.registro.enf_municipio = this.state.registro.enf_municipio.key;
    this.state.registro.enf_ambiente = this.state.registro.enf_ambiente.key;

    this.props.onSalvarClick(this.state.registro);
  };




  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };

  onInputChangeNFe = event => {
    const { registro } = this.state;
    registro['enf_nfe_numero'] = event;
    this.setState({ enf_nfe_numero: event });
  }

  onInputChangeNFeSerie = event => {
    const { registro } = this.state;
    registro['enf_nfe_serie'] = event;
    this.setState({ enf_nfe_serie: event });
  }

  onInputChangeNFCe = event => {
    const { registro } = this.state;
    registro['enf_nfce_numero'] = event;
    this.setState({ enf_nfce_numero: event });
  }

  onInputChangeNFCeSerie = event => {
    const { registro } = this.state;
    registro['enf_nfce_serie'] = event;
    this.setState({ enf_nfce_serie: event });
  }

  onInputChangeNFSe = event => {
    const { registro } = this.state;
    registro['enf_nfse_numero'] = event;
    this.setState({ enf_nfse_numero: event });
  }

  onInputChangeNFSeSerie = event => {
    const { registro } = this.state;
    registro['enf_nfse_serie'] = event;
    this.setState({ enf_nfse_serie: event });
  }

  onBuscarCEPClick = (cep) => {
    // console.log('onBuscarCEPClick: ', cep);
    const { registro } = this.state;

    const cepAux = cep ? cep.replace(/[^\d]/g, '') : '';
    if (cepAux) {
      this.setState({ carregandoCEP: true })
      fetch("https://viacep.com.br/ws/" + cep + "/json/")
        .then(res => res.json())
        .then(
          (result) => {
            // console.log('onBuscarCEPClick-OK: ', result);
            registro.enf_endereco = result.logradouro;
            registro.enf_bairro = result.bairro;
            registro.enf_municipio = {
              key: String(result.ibge),
              label: result.localidade,
              label: String(result.ibge) + ' - ' + result.localidade,
              cmun_uf: String(result.uf),
              cuf_sigla: result.uf,
            };

            this.setState({
              registro,
              carregandoCEP: false,
            })
          },
          (error) => {
            // console.log('onBuscarCEPClick-ERRO: ', error);
            this.setState({
              carregandoCEP: false,
            })
          }
        )
    }
  }


  onGerarTokenClick = () => {
    if (this.state.registro.enf_idf) {

      // if ((this.state.registro.enf_ambiente.key === '1') && (this.state.registro.enf_token_producao)) {
      //   Modal.info({ title: 'Atenção', width: '25%', content: 'Token já gerado', okText: 'OK', })
      //   return;
      // }
      // if ((this.state.registro.enf_ambiente.key === '2') && (this.state.registro.enf_token_homolog)) {
      //   Modal.info({ title: 'Atenção', width: '25%', content: 'Token já gerado', okText: 'OK', })
      //   return;
      // }


      if ((!this.state.registro.enf_cnpj) || (this.state.registro.enf_cnpj === '')) {
        Modal.warning({ title: 'Aviso!', content: 'Informe o CNPJ' });
        return;
      }
      const PFJ = this.state.registro.enf_cnpj
        ? this.state.registro.enf_cnpj
          .toUpperCase()
          .replace(/[^A-Z0-9]/g, '')
        : '';
      if (!CNPJValido(PFJ)) {
        Modal.warning({ title: 'Aviso!', content: 'CNPJ Inválido', });
        return;
      }
      if ((!this.state.registro.enf_razao_social) || (this.state.registro.enf_razao_social === '')) {
        Modal.warning({ title: 'Aviso!', content: 'Informe a Razão Social' });
        return;
      }

      if ((!this.state.registro.enf_cep) || (this.state.registro.enf_cep === '')) {
        Modal.warning({ title: 'Aviso!', content: 'Informe CEP' });
        return;
      }
      if ((!this.state.registro.enf_endereco) || (this.state.registro.enf_endereco === '')) {
        Modal.warning({ title: 'Aviso!', content: 'Informe Endereço' });
        return;
      }
      if ((!this.state.registro.enf_num_ender) || (this.state.registro.enf_num_ender === '')) {
        Modal.warning({ title: 'Aviso!', content: 'Informe nº endereço' });
        return;
      }
      if ((!this.state.registro.enf_bairro) || (this.state.registro.enf_bairro === '')) {
        Modal.warning({ title: 'Aviso!', content: 'Informe o bairro' });
        return;
      }
      if ((!this.state.registro.enf_municipio) || (this.state.registro.enf_municipio.key === '0') || (this.state.registro.enf_municipio.key === '')) {
        Modal.warning({ title: 'Aviso!', content: 'Informe o Município' });
        return;
      }

      if ((!this.state.registro.enf_crt) || (this.state.registro.enf_crt.key === '0') || (this.state.registro.enf_crt.key === '')) {
        Modal.warning({ title: 'Aviso!', content: 'Informe o Regime Tributário' });
        return;
      }


      Modal.confirm({
        title: 'Confirmação Token',
        content: `Deseja realmente gravar o token?`,
        okText: 'Sim',
        cancelText: 'Não',
        onOk: () => {

          this.setState({ carregandoToken: true });

          const reg = {
            emitente: this.state.registro.enf_idf,
            ambiente: this.state.registro.enf_ambiente.key,
          }

          axios.post('/emitenteNF/gerarTokenIntegraNotas', reg)
            .then(response => {
              const { data } = response;

              if (data.sucesso) {
                Modal.success({
                  title: 'Token',
                  okText: 'OK',
                  width: '25%',
                  content: (
                    <div>
                      <div>{'Token gravado com sucesso'}</div>
                    </div>
                  ),
                })
                this.props.onCancelarClick();
              } else {
                Modal.error({ title: 'Falha - Atenção!', width: '25%', content: 'Não foi possível Gravar o Token. ' + data.mensagem, okText: 'OK', })
              }
              this.setState({
                carregandoToken: false,
              })
            })
            .catch(error => {
              // console.log(error.response);
              Modal.error({ title: 'Erro ao Gravar Token', width: '25%', content: error.response.data.mensagem ? error.response.data.mensagem : '', okText: 'OK', })
              this.setState({
                carregandoToken: false,
              })
            })
        }
      })
    }
  }



  toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = (error) => reject(error);
    });

  beforeUpload = async (file) => {
    const nome = String(file && file.name ? file.name : '').toLowerCase();
    if (!nome.endsWith('.pfx') && !nome.endsWith('.p12')) {
      message.error('Selecione um arquivo PFX/P12 válido.');
      return Upload.LIST_IGNORE;
    }

    if (file.size && file.size > (5 * 1024 * 1024)) {
      message.error('O certificado deve ter no máximo 5 MB.');
      return Upload.LIST_IGNORE;
    }

    if (!this.state.registro.enf_senha_certificado) {
      Modal.info({
        title: 'Atenção',
        width: '25%',
        content: 'Informe a senha do certificado antes de selecionar o arquivo.',
        okText: 'OK',
      });
      return Upload.LIST_IGNORE;
    }

    try {
      const base64String = await this.toBase64(file);
      const registro = {
        ...this.state.registro,
        enf_certificado: base64String,
        enf_certificado_nome: file.name,
      };

      this.setState({ registro });
      message.success('Certificado selecionado. Ele será gravado ao salvar o emitente.');
    } catch (err) {
      console.error(err);
      Modal.error({
        title: 'Certificado digital',
        content: 'Não foi possível ler o certificado selecionado.',
        okText: 'OK',
      });
    }

    return false;
  };


  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { carregandoCEP, carregandoToken } = this.state;
    const { enf_idf, enf_razao_social, enf_cnpj, enf_cnae, enf_crt, enf_ie, enf_im, enf_email, enf_telefone, enf_cep, enf_endereco, enf_num_ender, enf_compl_ender, enf_bairro, enf_municipio,
      enf_ambiente, enf_enviar_nf_emissao, enf_nfe_numero, enf_flag_nfe, enf_nfe_serie, enf_nfce_numero, enf_flag_nfce, enf_nfce_serie, enf_csc, enf_idcsc, enf_nfse_numero, enf_flag_nfse, enf_nfse_serie, enf_login_prefeitura, enf_senha_prefeitura,
      enf_token_homolog, enf_token_producao, enf_webhook, enf_senha_certificado, enf_data_certificado,
      enf_certificado_nome, certificado_local
    } = this.state.registro;

    // console.log('EmitenteForm.this.state: ', this.state);

    return (
      <Modal
        title={enf_idf ? "Edição de Emitentes de NFe" : "Cadastro de Emitentes de NFe"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"60%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>

            <Row>
              <Col xs={24} sm={6} style={{ paddingRight: 10 }}>
                <span>CNPJ</span>
                <InputForm
                  id="enf_cnpj"
                  ref="enf_cnpj"
                  maxLength={20}
                  onChange={this.onChange}
                  value={enf_cnpj}
                  validator={value => Boolean(value)}
                  masker={maskCNPJ}
                />
              </Col>

              <Col xs={24} sm={18} style={{}}>
                <span>Razão Social</span>
                <InputForm
                  id="enf_razao_social"
                  ref="enf_razao_social"
                  maxLength={60}
                  onChange={this.onChange}
                  value={enf_razao_social}
                  validator={value => Boolean(value)}
                />
              </Col>

              <Col xs={24} sm={3} style={{ marginTop: -20 }}>
                <span>CEP</span>
                <InputForm
                  id="enf_cep"
                  ref="enf_cep"
                  value={enf_cep}
                  maxLength={10}
                  onChange={this.onChange}
                  validator={value => Boolean(value)}
                />
              </Col>

              <Col xs={24} sm={1} style={{ marginTop: 4, marginRight: 50 }}>
                <Tooltip title="Buscar Endereço" placement="topLeft">
                  <Button
                    type="dashed"
                    icon="search"
                    htmlType="button"
                    loading={carregandoCEP}
                    onClick={() => this.onBuscarCEPClick(enf_cep)}
                  />
                </Tooltip>
              </Col>

              <Col xs={24} sm={10} style={{ marginTop: -20, paddingRight: 10 }}>
                <span>Endereço</span>
                <InputForm
                  id="enf_endereco"
                  ref="enf_endereco"
                  maxLength={60}
                  onChange={this.onChange}
                  value={enf_endereco}
                  validator={value => Boolean(value)}
                />
              </Col>

              <Col xs={24} sm={9} style={{ marginTop: -20 }}>
                <span>Complemento</span>
                <InputForm
                  id="enf_compl_ender"
                  ref="enf_compl_ender"
                  maxLength={60}
                  onChange={this.onChange}
                  value={enf_compl_ender}
                  validator={value => Boolean(value)}
                />
              </Col>

              <Col xs={24} sm={4} style={{ marginTop: -20, paddingRight: 10 }}>
                <span>Nº</span>
                <InputForm
                  id="enf_num_ender"
                  ref="enf_num_ender"
                  maxLength={10}
                  onChange={this.onChange}
                  value={enf_num_ender}
                  validator={value => Boolean(value)}
                />
              </Col>

              <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 10 }}>
                <span>Bairro</span>
                <InputForm
                  id="enf_bairro"
                  ref="enf_bairro"
                  maxLength={60}
                  onChange={this.onChange}
                  value={enf_bairro}
                  validator={value => Boolean(value)}
                />
              </Col>

              <Col xs={24} sm={12} style={{ marginTop: -20 }}>
                <MunicipioFrame
                  label="Município"
                  id="enf_municipio"
                  value={enf_municipio}
                  width={"100%"}
                  onChange={this.onChangeMunicipio}
                  descricaoPrimeiroItem="Todos os Municípios"
                />
              </Col>

              <Col xs={24} sm={18} style={{ marginTop: -20, paddingRight: 10 }}>
                <span>Emial</span>
                <InputForm
                  id="enf_email"
                  ref="enf_email"
                  maxLength={100}
                  onChange={this.onChange}
                  value={enf_email}
                  validator={value => Boolean(value)}
                />
              </Col>

              <Col xs={24} sm={6} style={{ marginTop: -20 }}>
                <span>Telefone</span>
                <InputForm
                  id="enf_telefone"
                  ref="enf_telefone"
                  value={enf_telefone}
                  maxLength={15}
                  masker={maskTelefone}
                  onChange={this.onChange}
                  validator={value => Boolean(value)}
                />
              </Col>
            </Row>

            <div className="divider-lg-form" />

            <Row>
              <Col xs={24} sm={6} style={{ marginTop: 0, paddingRight: 10 }}>
                <span>CNAE</span>
                <InputForm
                  id="enf_cnae"
                  ref="enf_cnae"
                  maxLength={10}
                  onChange={this.onChange}
                  value={enf_cnae}
                  validator={value => Boolean(value)}
                />
              </Col>

              <Col xs={24} sm={6} style={{ marginTop: 0, paddingRight: 10 }}>
                <span>Inscr Est</span>
                <InputForm
                  id="enf_ie"
                  ref="enf_ie"
                  maxLength={15}
                  onChange={this.onChange}
                  value={enf_ie}
                  validator={value => Boolean(value)}
                />
              </Col>

              <Col xs={24} sm={6} style={{ marginTop: 0, paddingRight: 10 }}>
                <span>Inscr Mun</span>
                <InputForm
                  id="enf_im"
                  ref="enf_im"
                  maxLength={10}
                  onChange={this.onChange}
                  value={enf_im}
                  validator={value => Boolean(value)}
                />
              </Col>

              <Col xs={24} sm={6} style={{ marginTop: 0 }}>
                <span>Regime Tributário</span>
                <InputForm
                  type="select"
                  id="enf_crt"
                  ref="enf_crt"
                  value={enf_crt}
                  placeholder="Selecione o Tipo"
                  onChange={this.onChange}
                  data={OPCOES_COMBO_RT}
                  validator={value => Boolean(value)}
                  style={{ width: "100%" }}
                />
              </Col>
            </Row>

            <Row>
              <Col xs={24} sm={5} style={{ marginTop: -20, paddingRight: 10 }}>
                <span>Ambiente</span>
                <InputForm
                  type="select"
                  id="enf_ambiente"
                  ref="enf_ambiente"
                  value={enf_ambiente}
                  placeholder="Selecione o Tipo"
                  onChange={this.onChange}
                  data={OPCOES_COMBO_AMBIENTE}
                  validator={value => Boolean(value)}
                  style={{ width: "100%" }}
                />
              </Col>

              <Col xs={24} sm={3} style={{ marginTop: 4, paddingRight: 10 }}>
                <Tooltip title="Gravar Token para Emissão de Notas" placement="topLeft">
                  <Button
                    type="dashed"
                    htmlType="button"
                    loading={carregandoToken}
                    onClick={() => this.onGerarTokenClick(enf_cep)}
                    disabled={!enf_idf}
                  > Gravar Token </Button>
                </Tooltip>
              </Col>

              {/* <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 10 }}>
                <span>Token Produção</span>
                <InputForm
                  id="enf_token_producao"
                  ref="enf_token_producao"
                  maxLength={200}
                  onChange={this.onChange}
                  value={enf_token_producao}
                  validator={value => Boolean(value)}
                  readOnly
                />
              </Col> */}

              {/* <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 10 }}>
                <span>Token Homologação</span>
                <InputForm
                  id="enf_token_homolog"
                  ref="enf_token_homolog"
                  maxLength={200}
                  onChange={this.onChange}
                  value={enf_token_homolog}
                  validator={value => Boolean(value)}
                  readOnly
                />
              </Col> */}


              <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 10 }}>
                <span>Validade Certificado</span>
                <InputForm
                  id="enf_data_certificado"
                  ref="enf_data_certificado"
                  maxLength={200}
                  onChange={this.onChange}
                  value={enf_data_certificado}
                  validator={value => Boolean(value)}
                  readOnly
                />
              </Col>

              <Col xs={24} sm={4} style={{ marginTop: -20, paddingRight: 10 }}>
                <span>Senha Certificado</span>
                <InputForm
                  id="enf_senha_certificado"
                  ref="enf_senha_certificado"
                  type="password"
                  maxLength={200}
                  onChange={this.onChange}
                  value={enf_senha_certificado}
                  validator={value => Boolean(value)}
                />
              </Col>

              <Col xs={24} sm={3} style={{ marginTop: 4 }}>
                <Upload beforeUpload={this.beforeUpload} showUploadList={false}>
                  <Tooltip title="Anexar Certificado Digital" placement="topLeft">
                    <Button
                      type="dashed"
                      htmlType="button"
                    > Selecionar PFX </Button>
                  </Tooltip>
                </Upload>
              </Col>

              <Col xs={24} sm={7} style={{ marginTop: 8 }}>
                <span style={{ color: enf_certificado_nome || certificado_local ? '#389e0d' : '#999' }}>
                  {enf_certificado_nome
                    ? `Selecionado: ${enf_certificado_nome}`
                    : (certificado_local ? 'Certificado local já gravado' : 'Nenhum certificado selecionado')}
                </span>
              </Col>

              <Col xs={24} sm={24} style={{ marginTop: -16 }} className="campoCheckBox">
                <InputForm
                  type="checkbox"
                  id="enf_enviar_nf_emissao"
                  ref="enf_enviar_nf_emissao"
                  onChange={this.onChange}
                  value={enf_enviar_nf_emissao ? true : false}
                >
                  Enviar Email e WhatsApp na emissão
                </InputForm>
              </Col>

            </Row>

            <div className="divider-lg-form" />

            <Row>
              <Col xs={24} sm={4} style={{ marginTop: 8 }} className="campoCheckBox">
                <InputForm
                  type="checkbox"
                  id="enf_flag_nfe"
                  ref="enf_flag_nfe"
                  onChange={this.onChange}
                  value={enf_flag_nfe ? true : false}
                >
                  NFe (Completa)
                </InputForm>
              </Col>

              <Col xs={24} sm={10} style={{ marginTop: 10, paddingRight: 10 }}>
                <span>Nº NFe Atual</span>
                <InputNumber
                  ref="Input"
                  id={enf_nfe_numero}
                  value={enf_nfe_numero}
                  onChange={this.onInputChangeNFe}
                  min={0}
                  max={999999}
                  maxLength={6}
                  style={{ width: '100%' }}
                  disabled={!enf_flag_nfe}
                />
              </Col>

              <Col xs={24} sm={10} style={{ marginTop: 10 }}>
                <span>Série NFe</span>
                <InputNumber
                  ref="Input"
                  id={enf_nfe_serie}
                  value={enf_nfe_serie}
                  onChange={this.onInputChangeNFeSerie}
                  min={0}
                  max={999}
                  maxLength={6}
                  style={{ width: '100%' }}
                  disabled={!enf_flag_nfe}
                />
              </Col>
            </Row>

            <div className="divider-lg-form" style={{ marginTop: 0 }} />

            <Row>
              <Col xs={24} sm={4} style={{ marginTop: 8 }} className="campoCheckBox">
                <InputForm
                  type="checkbox"
                  id="enf_flag_nfce"
                  ref="enf_flag_nfe"
                  onChange={this.onChange}
                  value={enf_flag_nfce ? true : false}
                >
                  NFCe (Cupom)
                </InputForm>
              </Col>

              <Col xs={24} sm={4} style={{ marginTop: 10, paddingRight: 10 }}>
                <span>Nº NFCe Atual</span>
                <InputNumber
                  ref="Input"
                  id={enf_nfce_numero}
                  value={enf_nfce_numero}
                  onChange={this.onInputChangeNFCe}
                  min={0}
                  max={999999}
                  maxLength={6}
                  style={{ width: '100%' }}
                  disabled={!enf_flag_nfce}
                />
              </Col>

              <Col xs={24} sm={4} style={{ marginTop: 10, paddingRight: 10 }}>
                <span>Série NFCe</span>
                <InputNumber
                  ref="Input"
                  id={enf_nfce_serie}
                  value={enf_nfce_serie}
                  onChange={this.onInputChangeNFCeSerie}
                  min={0}
                  max={999}
                  maxLength={6}
                  style={{ width: '100%' }}
                  disabled={!enf_flag_nfce}
                />
              </Col>

              <Col xs={24} sm={4} style={{ marginTop: 5, paddingRight: 10 }}>
                <span>ID CSC</span>
                <InputForm
                  id="enf_csc"
                  ref="enf_csc"
                  maxLength={100}
                  onChange={this.onChange}
                  value={enf_csc}
                  validator={value => Boolean(value)}
                  disabled={!enf_flag_nfce}
                />
              </Col>

              <Col xs={24} sm={8} style={{ marginTop: 5 }}>
                <span>CSC</span>
                <InputForm
                  id="enf_idcsc"
                  ref="enf_idcsc"
                  maxLength={100}
                  onChange={this.onChange}
                  value={enf_idcsc}
                  validator={value => Boolean(value)}
                  disabled={!enf_flag_nfce}
                />
              </Col>
            </Row>

            <div className="divider-lg-form" style={{ marginTop: 0 }} />

            <Row>
              <Col xs={24} sm={4} style={{ marginTop: 5 }} className="campoCheckBox">
                <InputForm
                  type="checkbox"
                  id="enf_flag_nfse"
                  ref="enf_flag_nfse"
                  onChange={this.onChange}
                  value={enf_flag_nfse ? true : false}
                >
                  NFSe (Serviço)
                </InputForm>
              </Col>

              <Col xs={24} sm={4} style={{ marginTop: 10, paddingRight: 10 }}>
                <span>Nº NFSe Atual</span>
                <InputNumber
                  ref="Input"
                  id={enf_nfse_numero}
                  value={enf_nfse_numero}
                  onChange={this.onInputChangeNFSe}
                  min={0}
                  max={999999}
                  maxLength={6}
                  style={{ width: '100%' }}
                  disabled={!enf_flag_nfse}
                />
              </Col>

              <Col xs={24} sm={4} style={{ marginTop: 10, paddingRight: 10 }}>
                <span>Série NFSe</span>
                <InputNumber
                  ref="Input"
                  id={enf_nfse_serie}
                  value={enf_nfse_serie}
                  onChange={this.onInputChangeNFSeSerie}
                  min={0}
                  max={999}
                  maxLength={6}
                  style={{ width: '100%' }}
                  disabled={!enf_flag_nfse}
                />
              </Col>

              <Col xs={24} sm={6} style={{ marginTop: 10, paddingRight: 10 }}>
                <span>Login Prefeitura</span>
                <InputForm
                  id="enf_login_prefeitura"
                  ref="enf_login_prefeitura"
                  maxLength={100}
                  onChange={this.onChange}
                  value={enf_login_prefeitura}
                  validator={value => Boolean(value)}
                  disabled={!enf_flag_nfse}
                />
              </Col>

              <Col xs={24} sm={6} style={{ marginTop: 10 }}>
                <span>Senha Prefeitura</span>
                <InputForm
                  id="enf_senha_prefeitura"
                  ref="enf_senha_prefeitura"
                  type="password"
                  maxLength={100}
                  onChange={this.onChange}
                  value={enf_senha_prefeitura}
                  validator={value => Boolean(value)}
                  disabled={!enf_flag_nfse}
                />
              </Col>
            </Row>

            {/* <Col xs={24} sm={24} style={{ marginTop: -20 }}>
              <span>WebHooh</span>
              <InputForm
                id="enf_webhook"
                ref="enf_webhook"
                maxLength={100}
                onChange={this.onChange}
                value={enf_webhook}
                validator={value => Boolean(value)}
              />
            </Col> */}

          </Row>

          <ItemForm>
            <Row style={{ marginTop: 20 }}>
              <Col xs={24}>
                <Button
                  type="primary"
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="btn-salvar"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EmitenteForm.js